// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const contactService = async (data) => {
  return api('/Sellitback.svc/Contact', data, 'POST');
};

const contactPageDataService = async () => {
  return api('/api/v2/pages/?type=contact_page.ContactPage&fields=title,email,phone', {}, 'GET');
};

export {
  contactService,
  contactPageDataService,
};
